const aesReduxConstants = function() {
  return {
    // use this for a placeholder in actions that are not implemented yet
    TODO: 'aes/portal/TODO',

    HYDRATE_PORTAL: 'aes/portal/HYDRATE_PORTAL',

    NEW_PUB_SUB_PRODUCT_EVENT: 'aes/portal/pubsub/NEW_PUB_SUB_PRODUCT_EVENT',

    GET_PRODUCT_LIST: 'aes/portal/products/GET_PRODUCT_LIST',
    GET_PRODUCT_LIST_SUCCESS: 'aes/portal/products/GET_PRODUCT_LIST_SUCCESS',
    GET_PRODUCT_LIST_ERROR: 'aes/portal/products/GET_PRODUCT_LIST_ERROR',

    // get all products even products a client doesnt have
    GET_ALL_PRODUCTS: 'aes/portal/products/GET_ALL_PRODUCTS',
    GET_ALL_PRODUCTS_SUCCESS: 'aes/portal/products/GET_ALL_PRODUCTS_SUCCESS',
    GET_ALL_PRODUCTS_ERROR: 'aes/portal/products/GET_ALL_PRODUCTS_ERROR',

    GET_SEVERITY_LIST: 'aes/portal/GET_SEVERITY_LIST',

    UPDATE_PRODUCT_EVENT: 'aes/portal/products/UPDATE_PRODUCT_EVENT',
    UPDATE_PRODUCT_DETAILS: 'aes/portal/products/UPDATE_PRODUCT_DETAILS',
    APPEND_PRODUCT_EVENT: 'aes/portal/products/APPEND_PRODUCT_EVENT',
    APPEND_PRODUCT_DETAILS: 'aes/portal/products/APPEND_PRODUCT_DETAILS',

    GET_PRODUCT_DETAILS_LIST: 'aes/portal/products/GET_PRODUCT_DETAILS_LIST',
    GET_PRODUCT_DETAILS_LIST_SUCCESS: 'aes/portal/products/GET_PRODUCT_DETAILS_LIST_SUCCESS',
    GET_PRODUCT_DETAILS_SUCCESS: 'aes/portal/products/GET_PRODUCT_DETAILS_SUCCESS',
    GET_PRODUCT_DETAILS_ERROR: 'aes/portal/products/GET_PRODUCT_DETAILS_ERROR',

    GET_NOTIFICATIONS: 'aes/portal/notifications/GET_NOTIFICATIONS',
    GET_NOTIFICATIONS_SUCCESS: 'aes/portal/notifications/GET_NOTIFICATIONS_SUCCESS',

    APPEND_NOTIFICATION: 'aes/portal/notificiations/APPEND_NOTIFICATION',
    REPLACE_NOTIFICATION: 'aes/portal/notifications/REPLACE_NOTIFICATION',
    SET_ALL_AS_READ: 'aes/portal/notifications/SET_ALL_AS_READ',

    SET_CURRENT_PRODUCT_LOADING: 'aes/portal/currentproduct/SET_CURRENT_PRODUCT_LOADING',
    GET_CURRENT_PRODUCT: 'aes/portal/currentproduct/GET_CURRENT_PRODUCT',
    SET_CURRENT_PRODUCT_ACK_IN_PROGRESS: 'aes/portal/currentproduct/SET_CURRENT_PRODUCT_ACK_IN_PROGRESS',
    GET_CURRENT_PRODUCT_SUCCESS: 'aes/portal/currentproduct/GET_CURRENT_PRODUCT_SUCCESS',
    GET_CURRENT_PRODUCT_EVENT_ERROR: 'aes/portal/currentproduct/GET_CURRENT_PRODUCT_EVENT_ERROR',
    GET_CURRENT_PRODUCT_EVENT: 'aes/portal/currentproduct/GET_CURRENT_PRODUCT_EVENT',
    GET_CURRENT_PRODUCT_VERSIONS: 'aes/portal/currentproduct/GET_CURRENT_PRODUCT_EVENT_VERSIONS',

    GET_CURRENT_PRODUCT_DETAILS: 'aes/portal/currentproduct/GET_CURRENT_PRODUCT_DETAILS',

    REMOVE_PRODUCT_EVENT: 'aes/portal/products/REMOVE_PRODUCT_EVENT',
    REMOVE_PRODUCT_DETAILS: 'aes/portal/products/REMOVE_PRODUCT_DETAILS',

    GET_CLIENTS_AVAILABLE_PRODUCTS_SUCCESS: 'aes/portal/client/GET_CLIENTS_AVAILABLE_PRODUCTS_SUCCESS',

    GENERIC_ERROR: 'aes/portal/GENERIC_ERROR',
    CLEAR_ERRORS: 'aes/portal/CLEAR_ERRORS',

    PLAY_SOUND: 'aes/portal/sounds/PLAY_SOUND',
    STOP_ALL_SOUNDS: 'aes/portal/sounds/STOP_ALL_SOUNDS',
    STOP_PLAY_ONCE_AUDIO: 'aes/portal/sounds/STOP_PLAY_ONCE_AUDIO',
    STOP_LOOPED_AUDIO: 'aes/portal/sounds/STOP_LOOPED_AUDIO',

    PLAY_PRODUCT_EVENT_SOUNDS: 'aes/portal/sounds/PLAY_PRODUCT_EVENT_SOUNDS',
    PRODUCT_EVENT_SOUND_STOPPED: 'aes/portal/sounds/PRODUCT_EVENT_SOUND_STOPPED',
    SET_EVENTS_PLAYING_SOUND: 'aes/portal/sounds/SET_EVENTS_PLAYING_SOUND',

    SET_USER_CONTEXT: 'aes/portal/user/SET_USER_CONTEXT',
    SET_USER_SESSION: 'aes/portal/user/SET_USER_SESSION',
    GET_CLIENT_DETAILS: 'aes/portal/client/GET_CLIENT_DETAILS',

    SET_CURRENT_PRODUCT_AS_READ: 'aes/portal/currentproduct/SET_CURRENT_PRODUCT_AS_READ',
    SET_CURRENT_PRODUCT_AS_READ_SUCCESS: 'aes/portal/currentproduct/SET_CURRENT_PRODUCT_AS_READ_SUCCESS',
    SET_CURRENT_PRODUCT_AS_READ_FAILED: 'aes/portal/currentproduct/SET_CURRENT_PRODUCT_AS_READ_FAILED',
    SET_CURRENT_PRODUCT_LOADING_READ: 'aes/portal/currentproduct/SET_CURRENT_PRODUCT_LOADING_READ',

    // SOP Page Actions
    SOP_GENERIC_ERROR: 'aes/portal/sop/SOP_GENERIC_ERROR',
    SET_CURRENT_SOP_PAGE: 'aes/portal/sop/SET_CURRENT_SOP_PAGE',
    GET_CLIENT_SOP_LIST: 'aes/portal/sop/GET_CLIENT_SOP_LIST',
    GET_CLIENT_SOP_LIST_SUCCESS: 'aes/portal/sop/GET_CLIENT_SOP_LIST_SUCCESS',
    GET_CLIENT_SOP_PAGE_VERSIONS: 'aes/portal/sop/GET_CLIENT_SOP_PAGE_VERSIONS',
    GET_CLIENT_SOP_PAGE_VERSIONS_SUCCESS: 'aes/portal/sop/GET_CLIENT_SOP_PAGE_VERSIONS_SUCCESS',
    GET_CLIENT_SOP_PAGE: 'aes/portal/sop/GET_CLIENT_SOP_PAGE',
    GET_CLIENT_SOP_PAGE_NOT_FOUND: 'aes/portal/sop/GET_CLIENT_SOP_PAGE_NOT_FOUND',
    GET_CLIENT_SOP_PAGE_SUCCESS: 'aes/portal/sop/GET_CLIENT_SOP_PAGE_SUCCESS',
    UPDATE_CLIENT_SOP_PAGE: 'aes/portal/sop/UPDATE_CLIENT_SOP_PAGE',
    UPDATE_CLIENT_SOP_PAGE_SUCCESS: 'aes/portal/sop/UPDATE_CLIENT_SOP_PAGE_SUCCESS',
    CREATE_CLIENT_SOP_PAGE: 'aes/portal/sop/CREATE_CLIENT_SOP_PAGE',
    CREATE_CLIENT_SOP_PAGE_SUCCESS: 'aes/portal/sop/CREATE_CLIENT_SOP_PAGE_SUCCESS',
    ARCHIVE_CLIENT_SOP_PAGE: 'aes/portal/sop/ARCHIVE_CLIENT_SOP_PAGE',
    ARCHIVE_CLIENT_SOP_PAGE_SUCCESS: 'aes/portal/sop/ARCHIVE_CLIENT_SOP_PAGE_SUCCESS',
    UPDATE_CLIENT_SOP_LIST_ORDER: 'aes/portal/sop/UPDATE_CLIENT_SOP_LIST_ORDER',
    UPDATE_CLIENT_SOP_LIST_ORDER_SUCCESS: 'aes/portal/sop/UPDATE_CLIENT_SOP_LIST_ORDER_SUCCESS',
    GET_SOP_PAGE_PREVIEW: 'aes/portal/sop/GET_SOP_PAGE_PREVIEW',
    UPDATE_CURRENT_SOP_PAGE_CONTENT: 'aes/portal/sop/UPDATE_CURRENT_SOP_PAGE_CONTENT',
    UPDATE_CURRENT_SOP_PAGE_TITLE: 'aes/portal/sop/UPDATE_CURRENT_SOP_PAGE_TITLE',
    CLIENT: {
      GET_CLIENT_LICENSES: 'aes/portal/client/GET_CLIENT_LICENSES',
    },
    AFB_TOOLS: {
      GET_LOGIN_ATTEMPTS_ERROR: 'aes/portal/afb_tools/GET_LOGIN_ATTEMPTS_ERROR',
      GET_LOGIN_ATTEMPTS_SUCCESS: 'aes/portal/afb_tools/GET_LOGIN_ATTEMPTS_SUCCESS',
      GET_APP_TYPES_ERROR: 'aes/portal/afb_tools/GET_APP_TYPES_ERROR',
      GET_APP_TYPES_SUCCESS: 'aes/portal/afb_tools/GET_APP_TYPES_SUCCESS',
    },
    MAP: {
      HYDRATE: 'aes/portal/map/HYDRATE',
      STORE_BBOX: 'aes/portal/map/STORE_BBOX',
      STORE_MAP_STATE: 'aes/portal/map/STORE_MAP_STATE',
      OPEN_NAV: 'aes/portal/map/OPEN_NAV',
      CLOSE_NAV: 'aes/portal/map/CLOSE_NAV',
      GET_BASEMAPS: 'aes/portal/map/GET_BASEMAPS',
      QUICK_SEARCH: {
        PREFIX: 'QUICK_SEARCH/',
        QUICK_SEARCH_SET_QUERY: 'aes/portal/map/QUICK_SEARCH/GET_QUICK_SEARCH_SET_QUERY',
        QUICK_SEARCH_SUCCESS: 'aes/portal/map/QUICK_SEARCH/GET_QUICK_SEARCH_SUCCESS',
        QUICK_SEARCH_ERROR: 'aes/portal/map/QUICK_SEARCH/GET_QUICK_SEARCH_ERROR',
        QUICK_SEARCH: 'aes/portal/map/QUICK_SEARCH/GET_QUICK_SEARCH',
      },
      DROP_POINT: 'aes/portal/map/DROP_POINT',
      BASEMAP: {
        SET_DEFAULT: 'aes/portal/map/basemap/SET_DEFAULT',
      },
    },
    MAP_SET: {
      CREATE: 'aes/portal/map-sets/CREATE',
      DELETE: 'aes/portal/map-sets/DELETE',
      GET: 'aes/portal/map-sets/GET',
      GET_ALL: 'aes/portal/map-sets/GET_ALL',
      INVALIDATE_CACHE: 'aes/portal/map-sets/INVALIDATE_CACHE',
      SET_CURRENT: 'aes/portal/map-sets/SET_CURRENT',
      SET_DEFAULT: 'aes/portal/map-sets/SET_DEFAULT',
      UPDATE: 'aes/portal/map-sets/UPDATE',
    },
    MAP_VIEW: {
      CREATE: 'aes/portal/map-views/CREATE',
      DELETE: 'aes/portal/map-views/DELETE',
      GET: 'aes/portal/map-views/GET',
      GET_ALL: 'aes/portal/map-views/GET_ALL',
      INVALIDATE_CACHE: 'aes/portal/map-views/INVALIDATE_CACHE',
      SET_DEFAULT: 'aes/portal/map-views/SET_DEFAULT',
      UPDATE: 'aes/portal/map-views/UPDATE',
    },
    MAP_INSPECT: {
      INSPECT_LOCATION: 'aes/portal/MAP_INSPECT/INSPECT_LOCATION',
      INSPECT_LOCATION_SUCCESS: 'aes/portal/MAP_INSPECT/INSPECT_LOCATION_SUCCESS',
      INSPECT_LOCATION_ERROR: 'aes/portal/MAP_INSPECT/INSPECT_LOCATION_ERROR',
      UPDATE_INSPECT_LOCATION_SETTINGS: 'aes/portal/MAP_INSPECT/UPDATE_INSPECT_LOCATION_SETTINGS',
    },
    USER: {
      SET_LOCATION_SET_ID: 'aes/portal/user/SET_LOCATION_SET_ID',
    },
    AUDIT_LOG: {
      GET_DETAILS: 'aes/portal/audit/GET_DETAILS',
      GET_DETAILS_SUCCESS: 'aes/portal/audit/GET_DETAILS_SUCCESS',
      GET_DETAILS_ERROR: 'aes/portal/audit/GET_DETAILS_ERROR',

      GET_RELATED: 'aes/portal/audit/GET_RELATED',
      GET_RELATED_SUCCESS: 'aes/portal/audit/GET_RELATED_SUCCESS',
      GET_RELATED_ERROR: 'aes/portal/audit/GET_RELATED_ERROR',

      GET_LIST: 'aes/portal/audit/GET_LIST',
      GET_LIST_SUCCESS: 'aes/portal/audit/GET_LIST_SUCCESS',
      GET_LIST_ERROR: 'aes/portal/audit/GET_LIST_ERROR',

      GET_CLIENTS: 'aes/portal/audit/GET_CLIENTS',
      GET_CLIENTS_SUCCESS: 'aes/portal/audit/GET_CLIENTS_SUCCESS',
      GET_CLIENTS_ERROR: 'aes/portal/audit/GET_CLIENTS_ERROR',

      GET_USERS: 'aes/portal/audit/GET_USERS',
      GET_USERS_SUCCESS: 'aes/portal/audit/GET_USERS_SUCCESS',
      GET_USERS_ERROR: 'aes/portal/audit/GET_USERS_ERROR',

      GET_SUBJECTS: 'aes/portal/audit/GET_SUBJECTS',
      GET_SUBJECTS_SUCCESS: 'aes/portal/audit/GET_SUBJECTS_SUCCESS',
      GET_SUBJECTS_ERROR: 'aes/portal/audit/GET_SUBJECTS_ERROR',

      GET_ACTIONS: 'aes/portal/audit/GET_ACTIONS',
      GET_ACTIONS_SUCCESS: 'aes/portal/audit/GET_ACTIONS_SUCCESS',
      GET_ACTIONS_ERROR: 'aes/portal/audit/GET_ACTIONS_ERROR',
    },
  };
};

export default aesReduxConstants();
